{
  "accessDenied": "Erişim Reddedildi",
  "action": "İşlem",
  "active": "Aktif",
  "address": "Adres",
  "amount": "Tutar",
  "appName": "Exalt Exchange",
  "apply": "Uygula",
  "approved": "Onaylandı",
  "available": "Kullanılabilir",
  "back": "Geri",
  "balance": "Bakiye",
  "cancel": "İptal",
  "cancelled": "İptal Edildi",
  "cardProviderRequired": "Sağlayıcı entegrasyonu gerekli",
  "cardProviderRequiredDescription": "EXALT Kart henüz kullanılamıyor. Bu özelliğin kullanılabilmesi için gerçek bir kart sağlayıcısının bağlanması gerekir.",
  "close": "Kapat",
  "closed": "Kapalı",
  "coin": "Coin",
  "comingSoon": "Yakında",
  "completed": "Tamamlandı",
  "confirm": "Onayla",
  "continue": "Devam Et",
  "copy": "Kopyala",
  "copyFailed": "Kopyalama başarısız oldu.",
  "copyright": "Tüm hakları saklıdır.",
  "country": "Ülke",
  "currency": "Para Birimi",
  "date": "Tarih",
  "delete": "Sil",
  "description": "Açıklama",
  "details": "Detaylar",
  "disabled": "Devre Dışı",
  "download": "İndir",
  "edit": "Düzenle",
  "email": "E-posta",
  "enabled": "Etkin",
  "error": "Hata",
  "exaltCard": "EXALT Kart",
  "exchange": "Borsa",
  "failed": "Başarısız",
  "fast": "Hızlı",
  "fillAllRequiredFields": "Lütfen tüm zorunlu alanları doldurun.",
  "gated": "Sınırlı",
  "global": "Küresel",
  "inactive": "Pasif",
  "information": "Bilgi",
  "invalidRequest": "Geçersiz istek.",
  "language": "Dil",
  "languagePreferences": "Dil Tercihleri",
  "loading": "Yükleniyor...",
  "locked": "Kilitli",
  "lockedBalance": "Kilitli Bakiye",
  "name": "Ad",
  "network": "Ağ",
  "networkError": "Ağ hatası.",
  "next": "İleri",
  "no": "Hayır",
  "noAssetsFound": "Varlık bulunamadı.",
  "noDataFound": "Veri bulunamadı.",
  "noResultsFound": "Sonuç bulunamadı.",
  "noRewardsYet": "Henüz ödül yok.",
  "noRewardsYetDescription": "Gerçek referans ve stake ödülleri kazandığınızda burada görünecektir.",
  "notAvailable": "Kullanılamıyor",
  "notVerified": "Doğrulanmadı",
  "note": "Not",
  "notificationCenter": "Bildirimler",
  "open": "Aç",
  "openStatus": "Açık",
  "pending": "Beklemede",
  "permissionRequired": "Bu işlemi gerçekleştirme izniniz yok.",
  "phone": "Telefon",
  "pleaseLoginFirst": "Lütfen önce giriş yapın.",
  "price": "Fiyat",
  "processing": "İşleniyor...",
  "reference": "Referans",
  "referralProgram": "Referans",
  "refresh": "Yenile",
  "refreshing": "Yenileniyor...",
  "rejected": "Reddedildi",
  "remove": "Kaldır",
  "requestFailed": "İstek başarısız oldu.",
  "rewardsCenter": "Ödül Merkezi",
  "rewardsUnavailable": "Şu anda ödülleriniz yüklenemiyor.",
  "role": "Rol",
  "save": "Kaydet",
  "saving": "Kaydediliyor...",
  "search": "Ara",
  "searchAssets": "Varlık ara",
  "secure": "Güvenli",
  "sending": "Gönderiliyor...",
  "serverError": "Sunucu hatası.",
  "servicesHub": "Hizmetler",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
  "spot": "Spot",
  "status": "Durum",
  "submit": "Gönder",
  "submitting": "Gönderiliyor...",
  "success": "Başarılı",
  "system": "Sistem",
  "time": "Saat",
  "token": "Token",
  "total": "Toplam",
  "transactionHash": "İşlem Hash'i",
  "type": "Tür",
  "uid": "UID",
  "unauthorized": "Yetkisiz",
  "unlocked": "Kilidi Açık",
  "update": "Güncelle",
  "upload": "Yükle",
  "user": "Kullanıcı",
  "userId": "Kullanıcı ID",
  "value": "Değer",
  "verified": "Doğrulandı",
  "view": "Görüntüle",
  "viewAllNotifications": "Tüm Bildirimleri Görüntüle",
  "wallet": "Cüzdan",
  "walletAddress": "Cüzdan Adresi",
  "warning": "Uyarı",
  "yes": "Evet"
}